export enum KindPropertyType {
    Boolean = "Boolean",
    Hexadecimal = "Hexadecimal",
    Integer = "Integer",
    Decimal = "Decimal",
    String = "String",
    DateTime = "DateTime",
    Selection = "Selection",
    EntitySelection = "EntitySelection",
    Image = "Image",
    Images = "Images"
}
